import { createGlobalStyle } from "styled-components";

const StyleGlobal = createGlobalStyle`
  html,
  body, html {
      /* font-family: Roboto, "Segoe UI"; */
      .ant-select-selector{
        border-radius: 5px !important;
        border-color: #0089CF !important;
      }
      .google-visualization-tooltip {
        border:none !important;
        box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.25) !important; 
      }
    
  }
  .alert-comfirm-modal {
      .ant-btn-default {
        display: none;
      }
    }
  .confirmCustom {
      position: absolute;
      left: -50%;
      right: -50%;
      top: 35%;
      .ant-modal-body {
          padding: 20px;
          min-height: 5.875rem;
          margin-right: 0;
      }
      .ant-modal-content {
          border-radius: 5px;
          min-height: 5.875rem;
          .ant-modal-confirm-body-wrapper {
              width: 100%;
              min-height: 5.875rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .anticon-exclamation-circle {
                  display: none;
              }
              .ant-modal-confirm-title {
                  margin-top: -1em;
                  font-weight: 400;
                  font-size: 14px;
              }
              .ant-modal-confirm-btns {
                  width: 100%;
                  display: flex;
                  justify-content: flex-start;
                  flex-direction: row-reverse;
                  margin-bottom: -1em;
                  margin-top: 0;
                  .ant-btn-default {
                      color: #636e72;
                      border: none;
                      text-transform: uppercase;
                      font-size: 14px;
                      outline: none;
                      font-weight: 500;
                  }
                  .ant-btn-primary {
                      background: none;
                      border: none;
                      text-shadow: none;
                      box-shadow: none;
                      color: #CFAC00;
                      font-size: 14px;
                      font-weight: 500;
                  }
                  button:focus {
                      outline: none;
                  }
                  button:focus {
                      outline: none;
                  }
              }
          }
      }
  }
`;
export default StyleGlobal;
